import { createFileRoute } from '@tanstack/react-router'

import i18n from '@/i18n'
import { SchoolYearAddView } from '@/modules/schoolSettings'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute('/_auth/school-settings/years/add')({
  component: SchoolYearAddView,
  head: () =>
    getMetaWithPageTitle([
      i18n.t('title.add-new-school-year', { ns: 'schoolSettings' })
    ])
})
